import React, { lazy } from 'react';
import { Check } from 'lucide-react';
const BONUSES = [{
  title: 'Respiraciones que Calman',
  subtitle: '(60 segundos)',
  img: 'https://cdn.magicpatterns.com/uploads/oAVMLSeX3x7Yt9QGT67eZR/ChatGPT_Image_24_ene_2026,_10_45_55_p.m..png',
  desc: 'Técnica rápida para ayudarte a bajar ansiedad y recuperar tranquilidad mental en solo 1 minuto.'
}, {
  title: 'Rutinas Nocturnas',
  subtitle: 'para Dormir Mejor',
  img: 'https://cdn.magicpatterns.com/uploads/xaqLvvaU2RydaLARxW973P/ChatGPT_Image_24_ene_2026,_10_49_39_p.m..png',
  desc: 'Aprende una rutina simple para apagar tu mente antes de dormir y descansar profundamente.'
}];
const INCLUDES = ['Ebook "Calma tu mente en 5 minutos"', 'Bonus: Respiraciones que Calman', 'Bonus: Rutinas Nocturnas para Dormir Mejor', 'Acceso inmediato', 'Formato PDF descargable', 'Compatible con celular y computadora'];
export function IncludesSection() {
  return <section className="py-20 bg-white px-4" data-id="element-179">
      <div className="max-w-6xl mx-auto" data-id="element-180">
        <div className="text-center mb-16" data-id="element-181">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-6" data-id="element-182">
            Oferta Especial de Lanzamiento
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-183">
          <div className="order-2 lg:order-1" data-id="element-184">
            <div className="grid grid-cols-2 gap-2" data-id="element-185">
              {INCLUDES.map((item, i) => <div key={i} className="flex items-center gap-2 bg-[#FAF5EF] rounded-lg px-3 py-2" data-id="element-186">
                  <Check className="h-3.5 w-3.5 text-[#C06B6B] flex-shrink-0" data-id="element-187" />
                  <span className="text-sm text-gray-700" data-id="element-188">{item}</span>
                </div>)}
            </div>
          </div>
          <div className="order-1 lg:order-2 flex justify-center" data-id="element-189">
            <img src="https://cdn.magicpatterns.com/uploads/8U6jwPDsPXzUm5bwg9GMyE/ChatGPT_Image_24_ene_2026,_10_43_52_p.m..png" alt="Ebook Calma tu Mente en 5 Minutos" className="w-3/4 max-w-md shadow-2xl rounded-lg rotate-3 hover:rotate-0 transition-transform duration-500" loading="lazy" data-id="element-190" />
          </div>
        </div>

        {/* Bonuses */}
        <div className="bg-[#FAF5EF] rounded-3xl p-8 md:p-12" data-id="element-191">
          <h3 className="text-2xl font-serif font-bold text-center text-[#C4973B] mb-12" data-id="element-192">
            🎁 + 2 Bonos incluidos
          </h3>

          <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-193">
            {BONUSES.map((bonus, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-194">
                <img src={bonus.img} alt={bonus.title} className="w-48 shadow-xl rounded-md mb-6 hover:scale-105 transition-transform" loading="lazy" data-id="element-195" />
                <h4 className="text-xl font-bold text-gray-900" data-id="element-196">
                  {bonus.title}
                </h4>
                <p className="text-[#C06B6B] font-medium mb-2" data-id="element-197">
                  {bonus.subtitle}
                </p>
                <p className="text-sm text-gray-600 max-w-xs" data-id="element-198">{bonus.desc}</p>
              </div>)}
          </div>

          <div className="text-center pt-8 border-t border-[#C4973B]/20" data-id="element-199">
            <p className="text-gray-500 line-through mb-1" data-id="element-200">
              Valor total: $75 USD
            </p>
            <p className="text-2xl font-bold text-[#C06B6B]" data-id="element-201">Hoy: $11.99 USD</p>
            <p className="text-sm text-[#C06B6B]/80 font-semibold mt-1" data-id="element-202">
              Ahorras $63 hoy (84% descuento)
            </p>
            <p className="text-xs text-gray-500 mt-1 mb-6" data-id="element-203">
              📲 Acceso inmediato · Formato PDF descargable
            </p>

            <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-block w-full sm:w-auto rounded-full bg-[#C4973B] px-8 py-4 text-lg font-bold text-white shadow-md hover:bg-[#B08632] hover:shadow-lg transition-all transform hover:-translate-y-0.5 mb-3" data-id="element-204">
              👉 QUIERO MI EBOOK + BONOS GRATIS
            </a>
          </div>
        </div>
      </div>
    </section>;
}